<template>
  <div class="bgFrame">
    <div
      class="box"
      style="z-index: 499; display: flex; justify-content: center"
    >
      <div :class="boxClass"></div>
    </div>
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
    </div>
    <div
      class="box"
      style="z-index: 501; display: flex; justify-content: center"
    >
      <div class="textFrame">
        <div style="width: 100%; margin-top: 102px;"></div>
        <div style="position: relative;display: flex; justify-content: center">
          <div :class="titleClass">用户分享</div>
          <div style='position: absolute;margin-left:-50px;top:20px;text-align: left;font-size: 102px;font-family: DINCondensed-Bold, DINCondensed;font-weight: bold;color: rgba(128, 113, 101, 0.1);line-height: 100px;'>User Sharing</div>
        </div>
        <div style="width: 100%; margin-top: 52px;"></div>
        <div style="width: 100%; padding-top: 40%; position: relative">
          <div
            class="btn"
            style="justify-content: flex-end"
            id="btnleft"
            @click="controlLeft"
          >
            <img
              :id="leftBtn"
              src="../../assets/btn_arrow_l_w.png"
              style="width: 36px; margin-right: 15px"
            />
          </div>
          <swiper
            :allowTouchMove="false"
            :loop="true"
            :slidesPerView="3"
            :centeredSlides="true"
            :spaceBetween="20"
            @afterInit="initswiper"
            :pagination="{
              type: 'fraction',
            }"
            :navigation="false"
            :modules="modules"
            :class="swiperClass"
          >
            <swiper-slide v-for="(item, index) in goodsList" :key="index">
              <share style="width: 100%; height: 100%" :data="item"></share>
            </swiper-slide>
          </swiper>
          <div
            class="btn"
            id="btnright"
            style="justify-content: flex-start"
            @click="controlRight"
          >
            <img
              :id="rightBtn"
              src="../../assets/btn_arrow_r_w.png"
              style="width: 36px; margin-left: 15px"
            />
          </div>
        </div>
        <div style="width: 100%; margin-top: 4%"></div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            position: relative;
          "
          @mouseout="outMouse"
          @mouseover="overMouse"
        >
          <el-button
            round
            :id="sendBtn"
            class="orderBtn"
            color="white"
            size="large"
            >前往點餐</el-button
          >
           <div id="trangles" class="trangles" style="display: none;position: absolute;top:-13px;z-index:999;"></div>
           <div id="showCodes" style="display: none;position: absolute;top: -145px;width:133px;height:133px;background:white;border-radius: 5px; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);z-index:998;">
              <qrcode-vue class="qrCode" value="https://www.numatch.com.hk/oae/#/homePage" width="400" height="400" level="H" style="width:120px;height:120px;margin-top:6px;" />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted , watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import Share from "./share.vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";
import QrcodeVue from "qrcode.vue";

export default {
  name: "App",
  components: {
    Share,
    Swiper,
    SwiperSlide,
    QrcodeVue,
  },
  props: {
    design: Object,
  },
  setup(props) {

    watch(
        () => props.design,
            (newProps) => {
              let a = []
              for (let i = 0 ;i < newProps.length; i++) {
                let temp = newProps[i]
                a.push({text: temp.comments, img: temp.url, text1: temp.nickName + ' ' + temp.occupation + ' ' + temp.age + '歲', text2: temp.label})
              }
              goodsList.value = a
            }
        );

    onMounted(() => {


    });
    const swiperRef = ref(null);
    const goodsList = ref([
      
    ]);
    const initswiper = (swiper) => {
      swiperRef.value = swiper;
    };

    const controlLeft = () => {
      swiperRef.value.slidePrev(300, true);
    };
    const controlRight = () => {
      swiperRef.value.slideNext(300, true);
    };
    let titleClass = ref("start_textSubFrame");
    let swiperClass = ref("start_swiper1");
    let leftBtn = ref("start_btnsleft");
    let rightBtn = ref("start_btnsright");
    let sendBtn = ref("start_sendBtn");

    const startAnime = ref(false);

    const searchSlider = () => {
      if (swiperRef.value.activeIndex != goodsList.value.length + 1) {
        swiperRef.value.slideNext(0, true);
        setTimeout(() => {
          searchSlider();
        }, 50);
      }
    };

    let boxClass = ref('box_normal')
    const changeAnime = () => {
      startAnime.value = false
      searchSlider();
      titleClass.value = "start_textSubFrame";
      swiperClass.value = "start_swiper1";
      leftBtn.value = "start_btnsleft";
      rightBtn.value = "start_btnsright";
      sendBtn.value = "start_sendBtn";
      boxClass.value = 'box_normal'
      setTimeout(() => {
        boxClass.value = 'box_anime'
        titleClass.value = "textSubFrame";
        swiperClass.value = "swiper1";
        setTimeout(() => {
          startAnime.value = true
          leftBtn.value = "btnsleft";
          rightBtn.value = "btnsright";
          sendBtn.value = "sendBtn";
        }, 800);
      }, 800);
    };

    const outMouse = () => {
      if (startAnime.value == false) return
      let a = document.getElementById("showCodes");
      a.style.display = "none";
      let b = document.getElementById("trangles");
      b.style.display = "none";
    };
    const overMouse = () => {
      if (startAnime.value == false) return
      let a = document.getElementById("showCodes");
      a.style.display = "block";
      let b = document.getElementById("trangles");
      b.style.display = "block";
    };

    let pointImg = ref(require('../../assets/noise.png'))
    return {
      boxClass,
      pointImg,
      outMouse,
      overMouse,
      leftBtn,
      rightBtn,
      sendBtn,
      swiperClass,
      titleClass,
      startAnime,
      changeAnime,
      goodsList,
      controlRight,
      controlLeft,
      initswiper,
      swiperRef,
      modules: [Pagination, Navigation],
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  position:absolute;
  left:0px;
  width:1582px;
  bottom:0px;
  top:0px;
  border-top-right-radius: 300px;
  background:#8CA866;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}
.box_normal{
  position:absolute;
  left:0px;
  width:1582px;
  bottom:0px;
  top:0px;
  border-top-right-radius: 300px;
  background:#8CA866;
  opacity: 0;
}
.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgb(235, 242, 241);
}
.box {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.textFrame {
  height: 100%;
  width: 1220px;
  display: flex;
  flex-direction: column;
  align-content: center;
}

@keyframes textSubAnime {
  from {
    transform: translate(0px, -20px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.textSubFrame {
  font-size: 57px;
  color: white;
  font-family: MicrosoftYaHeiLight;
  animation-name: textSubAnime;
  animation-duration: 0.7s;
  animation-timing-function: ease-in-out;
  opacity: 1;
}
.start_textSubFrame {
  font-size: 57px;
  font-family: MicrosoftYaHeiLight;
  color: white;
  opacity: 0;
}
.textTitle {
  font-size: 36px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  text-align: left;
}
.textImg {
  width: calc(100% / 338 * 312);
  aspect-ratio: 312 / 19;
}
.textContent {
  width: calc(100% / 594 * 334);
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 16px;
}
.largeImg {
  width: 100%;
  aspect-ratio: 594 / 312;
  display: flex;
  justify-content: left;
}
.btn {
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
}
#btnleft {
  position: absolute;
  top: 0px;
}
@keyframes btnAnime {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
#btnsright {
  opacity: 1;
  animation-name: btnAnime;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
}
#start_btnsright {
  opacity: 0;
}
#btnsleft {
  opacity: 1;
  animation-name: btnAnime;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
}
#start_btnsleft {
  opacity: 0;
}
#btnright {
  position: absolute;
  top: 0px;
  right: 0px;
}
@keyframes swiperAnime {
  from {
    transform: translate(0px, 20px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.swiper1 {
  overflow: hidden;
  width: calc(80%);
  margin-left: 10%;
  height: 100%;
  top: 0px;
  position: absolute;
  opacity: 1;
  animation-name: swiperAnime;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
}
.start_swiper1 {
  overflow: hidden;
  width: calc(80%);
  margin-left: 10%;
  height: 100%;
  top: 0px;
  position: absolute;
  opacity: 0;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background-color: rgba(232, 233, 235, 0);
  display: -webkit-box;
  display: -ms-flexbox;

  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.orderBtn {
  width: 470px;
  height: 65px;
  border-radius: 32px !important;
}
@keyframes sendBtnAnime {
  from {
    transform: translate(0px, 20px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
#sendBtn {
  opacity: 1;
  animation-name: sendBtnAnime;
  animation-duration: 0.7s;
  animation-timing-function: ease-in-out;
  :deep(span){
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
}
#start_sendBtn {
  opacity: 0;
}

.trangles{
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid white;
  z-index: 999;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1s steps(2) infinite;
}

</style>
